import React from 'react';
import PropTypes from 'prop-types';
import SelectWithLabel from '../base/SelectWithLabel/SelectWithLabel';
import textTranslates from './translate.json';

const ComplaintTypeSelect = ({complaintType, complaintTypes, disabled, onComplaintTypeChanged, }) => {
    return(
        <div className="col-xs-12">
            <SelectWithLabel
                className="col-xs-12 col-sm-6"
                disabled={disabled}
                label={textTranslates.complaintTypeSelectLabel}
                onChange={onComplaintTypeChanged}
                value={complaintType.value}
                values={complaintTypes}/>
        </div>
    );
};

ComplaintTypeSelect.propTypes = {
    complaintType: PropTypes.shape({
        displayName: PropTypes.string,
        value: PropTypes.string
    }),
    complaintTypes: PropTypes.arrayOf(
        PropTypes.shape({
            displayName: PropTypes.string,
            value: PropTypes.string
        })
    ),
    disabled: PropTypes.bool,
    onComplaintTypeChanged: PropTypes.func
};

export default ComplaintTypeSelect;


// WEBPACK FOOTER //
// ./src/components/ComplaintTypeSelect/ComplaintTypeSelect.js